import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
// import logo from "./logo.svg";
import "./App.css";
import Login from "./pages/Login";
import ServiceSelection from "./pages/ServiceSelection";
import ActionSelection from "./pages/ActionSelection";
import CheckNumberForm from "./pages/CheckNumberForm";
import VerifyCodeForm from "./pages/VerifyCodeForm";
import NewNumberForm from "./pages/NewNumberForm";
import NewSSNumberForm from "./pages/NewSSNumberForm";
import { syncAxiosAuthHeader } from "./utils/auth";

function App() {
  useEffect(() => {
    syncAxiosAuthHeader();
  }, []);

  return (
    <div className="">
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/selfservice" element={<ServiceSelection />} />
          <Route path="/selfservice/synthetic" element={<ActionSelection />} />
          <Route path="/selfservice/continuation" element={<ActionSelection />} />
          <Route path="/selfservice/continuation/check-number" element={<CheckNumberForm />} />
          <Route path="/selfservice/continuation/verify-code" element={<VerifyCodeForm />} />
          <Route path="/selfservice/continuation/new-account" element={<NewNumberForm />} />
          <Route path="/selfservice/synthetic/new-account" element={<NewSSNumberForm />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
